import type { LucideIcon as LucideIconType } from 'lucide-react';
import {
  BadgeCheck,
  Bean,
  CircleDot,
  Droplets,
  Egg,
  Fish,
  FlaskConical,
  Flower2,
  Leaf,
  LeafyGreen,
  Milk,
  MilkOff,
  Nut,
  Salad,
  Shell,
  Shrimp,
  Sprout,
  Wheat,
  WheatOff,
} from 'lucide-react';

const LUCIDE_BY_KEY: Record<string, LucideIconType> = {
  Wheat,
  WheatOff,
  Shell,
  Shrimp,
  Egg,
  Fish,
  Nut,
  Bean,
  Milk,
  MilkOff,
  LeafyGreen,
  Droplets,
  CircleDot,
  FlaskConical,
  Flower2,
  Leaf,
  Sprout,
  Salad,
  BadgeCheck,
};

export function resolveLucideByIconKey(iconKey: string | null | undefined): LucideIconType | null {
  if (!iconKey) {
    return null;
  }
  return LUCIDE_BY_KEY[iconKey] ?? null;
}
